import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { Component } from '../component';
import Popover from '../Popover';

var RemoveConfirm =
/*#__PURE__*/
function (_Component) {
  _inherits(RemoveConfirm, _Component);

  var _super = _createSuper2(RemoveConfirm);

  function RemoveConfirm(props) {
    var _this;

    _classCallCheck(this, RemoveConfirm);

    _this = _super.call(this, props);
    _this.state = {
      visible: false
    };
    _this.handleRemoveConfirm = _this.handleRemoveConfirm.bind(_assertThisInitialized(_this));
    _this.handleRemoveLater = _this.handleRemoveLater.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(RemoveConfirm, [{
    key: "handleRemoveConfirm",
    value: function handleRemoveConfirm(visible) {
      var onVisibleChange = this.props.onVisibleChange;
      if (onVisibleChange) onVisibleChange(visible);
      this.setState({
        visible: visible
      });
    }
  }, {
    key: "handleRemoveLater",
    value: function handleRemoveLater() {
      var onRemove = this.props.onRemove;
      return new Promise(function (resolve) {
        if (onRemove) onRemove();
        resolve(undefined);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var visible = this.state.visible;
      var confirm = this.props.confirm;
      if (!confirm) return null;
      var confirmProps = typeof confirm === 'object' ? confirm : {
        children: confirm
      };
      return (
        /*#__PURE__*/
        React.createElement(Popover.Confirm, Object.assign({}, confirmProps, {
          onOk: this.handleRemoveLater,
          visible: visible,
          onVisibleChange: this.handleRemoveConfirm
        }))
      );
    }
  }]);

  return RemoveConfirm;
}(Component);

export { RemoveConfirm as default };